import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

export default function NotFound() {
  return (
    <div className="container-page section flex flex-col items-start" data-testid="not-found-page">
      <Reveal className="max-w-2xl">
        <span className="section-index">Errore 404</span>
        <h1 className="mt-6 font-mono text-[clamp(1.75rem,4vw,3rem)] font-medium uppercase tracking-mono text-foreground">
          Componente non trovato
        </h1>

        {/* Sagoma di un dispositivo a cui manca un pezzo, pulsa lentamente */}
        <div className="rn-pulse mt-12" style={{ animationDuration: "3.2s" }} aria-hidden="true">
          <svg width="120" height="200" viewBox="0 0 120 200" fill="none">
            <rect x="4" y="4" width="112" height="192" rx="18" fill="#141416" stroke="#2E2E33" />
            <rect x="48" y="10" width="24" height="6" rx="3" fill="#0A0A0B" />
            {/* Pezzo mancante */}
            <rect x="60" y="86" width="40" height="40" fill="#0A0A0B" stroke="#C6F24E" strokeWidth="1" strokeDasharray="4 4" />
          </svg>
        </div>

        <p className="mt-10 max-w-md text-lg leading-relaxed text-muted-foreground">
          La pagina che cerchi non esiste o è stata spostata. Torniamo al catalogo verificato.
        </p>
        <Link
          to="/"
          className="group mt-8 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-mono text-lime"
          data-testid="not-found-home-link"
        >
          Torna alla home
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 ease-out-expo group-hover:translate-x-1" strokeWidth={2} />
        </Link>
      </Reveal>
    </div>
  );
}
